import {
  GoogleAuthProvider,
  onAuthStateChanged,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithPopup,
} from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import { FaLock, FaMobile, FaUser } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { MdSms } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { fAuth } from "../../firebase";

const provider = new GoogleAuthProvider();

const ResendOtpButton = ({ onClick }) => {
  const [seconds, setSeconds] = useState(45);
  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [seconds]);
  return (
    <button
      type="button"
      disabled={seconds > 0}
      onClick={seconds > 0 ? onClick : () => null}
      className={`text-sm text-blue-400 hover:text-blue-30 ${
        seconds > 0 ? "cursor-not-allowed opacity-50" : ""
      }`}
    >
      Resend OTP{" "}
      {seconds > 0 ? `in 0:${seconds.toString().padStart(2, "0")}` : ""}
    </button>
  );
};

const LoginPage = () => {
  const navigate = useNavigate();
  const otpConfirmation = useRef(null);
  const [isPasswordLogin, setIsPasswordLogin] = useState(false);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    mobile: "",
    otp: "",
  });
  const [showOtpInput, setShowOtpInput] = useState(false);

  const sendOTP = async () => {
    if (/^\d{10}$/.test(formData.mobile) === false) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          fAuth,
          "recaptcha-container",
          {
            size: "invisible",
          }
        );
      }

      const confirmation = await signInWithPhoneNumber(
        fAuth,
        "+91" + formData.mobile,
        window.recaptchaVerifier
      );
      otpConfirmation.current = confirmation;

      console.log("OTP sent successfully!", confirmation);
      setShowResendOtp(true);
      setShowOtpInput(true);
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert(error.message);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isPasswordLogin) {
      // Handle password login
      console.log("Password login:", formData.username, formData.password);
      // After successful login, navigate to dashboard
      navigate("/dashboard");
    } else if (showOtpInput) {
      // Handle OTP verification
      console.log("OTP verification:", formData.mobile, formData.otp);
      // After successful verification, navigate to dashboard
      // navigate("/dashboard");
      if (otpConfirmation.current) {
        otpConfirmation.current
          .confirm(formData.otp)
          .then((result) => {
            console.log("OTP verification success:", result);
          })
          .catch((error) => {
            if (error.code === "auth/invalid-verification-code") {
              alert("Invalid OTP. Please check and try again.");
            } else {
              alert("Error verifying OTP: " + error.message);
            }
          });
      }
    } else {
      // Send OTP
      console.log("Sending OTP to:", formData.mobile);
      sendOTP();
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    onAuthStateChanged(fAuth, (user) => {
      if (user) {
        navigate("/dashboard");
      }
    });
  }, [navigate]);

  const handleGoogleLogin = () => {
    console.log("Google login clicked");
    signInWithPopup(fAuth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        // ...

        console.log("Google login success:", user, credential);
        // After successful login, navigate to dashboard
        navigate("/dashboard");
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-gray-800 to-gray-900 px-4 sm:px-6">
      <div className="bg-white/10 backdrop-blur-lg p-4 sm:p-8 rounded-xl shadow-2xl w-full max-w-md border border-white/20">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 sm:mb-8 text-white">
          Welcome Back
        </h2>

        <button
          onClick={handleGoogleLogin}
          className="w-full mb-4 sm:mb-6 py-2.5 sm:py-3 px-4 bg-white text-gray-800 rounded-lg hover:bg-gray-100 transition-all flex items-center justify-center gap-2 shadow-md text-sm sm:text-base"
        >
          <FcGoogle className="text-xl" />
          <span className="font-medium">Continue with Google</span>
        </button>

        {false && (
          <div className="relative mb-4 sm:mb-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-400/30"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 text-gray-300 bg-gray-800/50 backdrop-blur-sm">
                Or continue with
              </span>
            </div>
          </div>
        )}

        {/* <div className="flex mb-4 sm:mb-6 text-sm sm:text-base">
          <button
            className={`flex-1 py-2 text-center ${
              isPasswordLogin
                ? "border-b-2 border-blue-400 text-blue-400"
                : "text-gray-400 hover:text-gray-300"
            }`}
            onClick={() => setIsPasswordLogin(true)}
          >
            Password Login
          </button>
          <button
            className={`flex-1 py-2 text-center ${
              !isPasswordLogin
                ? "border-b-2 border-blue-400 text-blue-400"
                : "text-gray-400 hover:text-gray-300"
            }`}
            onClick={() => {
              setIsPasswordLogin(false);
              setShowOtpInput(false);
            }}
          >
            OTP Login
          </button>
        </div> */}

        {false && (
          <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
            {isPasswordLogin ? (
              <>
                <div className="relative">
                  <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                  <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={formData.username}
                    onChange={handleInputChange}
                    className="w-full pl-9 sm:pl-10 px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 text-sm sm:text-base"
                    required
                  />
                </div>
                <div className="relative">
                  <FaLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="w-full pl-9 sm:pl-10 px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 text-sm sm:text-base"
                    required
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    className="text-sm text-blue-400 hover:text-blue-300"
                  >
                    Forgot Password?
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="relative">
                  <FaMobile className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number (10-digit)"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    className="w-full pl-9 sm:pl-10 px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 text-sm sm:text-base"
                    required
                  />
                </div>
                {showOtpInput && (
                  <div className="space-y-2">
                    <div className="relative">
                      <MdSms className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
                      <input
                        type="text"
                        name="otp"
                        placeholder="Enter OTP"
                        value={formData.otp}
                        onChange={handleInputChange}
                        className="w-full pl-9 sm:pl-10 px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 text-sm sm:text-base"
                        required
                      />
                    </div>
                    {showResendOtp && (
                      <div className="flex justify-end">
                        <ResendOtpButton onClick={sendOTP} />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            <button
              type="submit"
              className="w-full py-2.5 sm:py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800 transition-all transform hover:scale-[1.02] text-sm sm:text-base"
            >
              {isPasswordLogin
                ? "Login"
                : showOtpInput
                ? "Verify OTP"
                : "Send OTP"}
            </button>
          </form>
        )}

        {/* <p className="mt-4 sm:mt-6 text-center text-xs sm:text-sm text-gray-400">
          Don't have an account?{" "}
          <button
            onClick={() => navigate("/register")}
            className="text-blue-400 hover:text-blue-300 font-medium"
          >
            Sign up
          </button>
        </p> */}
      </div>
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default LoginPage;
